"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drag = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Drag = function Drag() {
  return react_1.default.createElement("path", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M19.4999 2.76923C19.4999 4.29864 18.2407 5.53846 16.6874 5.53846C15.1341 5.53846 13.8749 4.29864 13.8749 2.76923C13.8749 1.23983 15.1341 0 16.6874 0C18.2407 0 19.4999 1.23983 19.4999 2.76923ZM16.6874 14.7692C18.2407 14.7692 19.4999 13.5293 19.4999 11.9999C19.4999 10.4705 18.2407 9.23071 16.6874 9.23071C15.1341 9.23071 13.8749 10.4705 13.8749 11.9999C13.8749 13.5293 15.1341 14.7692 16.6874 14.7692ZM16.6874 23.9999C18.2407 23.9999 19.4999 22.7601 19.4999 21.2307C19.4999 19.7013 18.2407 18.4614 16.6874 18.4614C15.1341 18.4614 13.8749 19.7013 13.8749 21.2307C13.8749 22.7601 15.1341 23.9999 16.6874 23.9999ZM7.3125 24C8.8658 24 10.125 22.7602 10.125 21.2308C10.125 19.7014 8.8658 18.4615 7.3125 18.4615C5.7592 18.4615 4.5 19.7014 4.5 21.2308C4.5 22.7602 5.7592 24 7.3125 24ZM10.125 12C10.125 13.5294 8.8658 14.7692 7.3125 14.7692C5.7592 14.7692 4.5 13.5294 4.5 12C4.5 10.4706 5.7592 9.23077 7.3125 9.23077C8.8658 9.23077 10.125 10.4706 10.125 12ZM7.3125 5.53846C8.8658 5.53846 10.125 4.29864 10.125 2.76923C10.125 1.23983 8.8658 0 7.3125 0C5.7592 0 4.5 1.23983 4.5 2.76923C4.5 4.29864 5.7592 5.53846 7.3125 5.53846Z",
    fill: "currentColor"
  });
};

exports.Drag = Drag;